// extracted by mini-css-extract-plugin
module.exports = {"header":"MFormCard_header__2Zl7K"};